<h2 mat-dialog-title>
  {{ data.title }}
  <span class="icon-close icon-Cross" mat-dialog-close></span>
</h2>
<mat-dialog-content>
  <div class="youtube">
    <div class="youtube__iframe">
      <iframe width="100%" height="100%" [src]="sanitizedVideoUrl" allowfullscreen [title]="data.title"> </iframe>
    </div>
    <pre class="youtube__description" [innerHTML]="linkify(data.description)"></pre>
    <div class="youtube__tags">
      <app-filter-tags-label *ngFor="let tag of data.tags" [label]="{ name: tag }" [isActive]="true"></app-filter-tags-label>
    </div>
  </div>
</mat-dialog-content>
